import EscapeRegEx from 'lib/escape-regex'

const highlighter = (text: string, key: string): string => {
  const regex = new RegExp(EscapeRegEx(key), 'i')
  key = text.match(regex) ? text.match(regex)[0] : ''
  return text?.replace(regex, `<strong>${key}</strong>`)
}

export default highlighter
